var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService, prepareParams, } from "./baseService";
class EmployeeCrewService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "employee_crew";
    }
    getAllWorkerCrews(options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const params = prepareParams(options);
            const { data } = yield this.api.get(`/${this.controllerName}/hierarchy`, {
                params,
            });
            return data;
        });
    }
}
export const employeeCrewService = new EmployeeCrewService();
//# sourceMappingURL=employeeCrewService.js.map